// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4683d7a6","617":"e2e2390e"}[chunkId] + ".chunk.js";
};